export default __webpack_public_path__ + "static/media/poster_save_d.a16bd258.jpg";